import { UsersLocationFiles } from '../Tracker/Tracker.types'
import {
  CallResult,
  FileMeta,
  FilesContents,
  FilesMeta,
  IsClosed,
  SyncLock,
  TableName,
  TipFile,
  User,
  Walk,
} from '../store/dbTypes'
import {
  createFbStorageFile,
  createFbStorageJsonFile,
  deleteFbStorageFile,
  downloadFbStorageFile,
  getFbStorageJsonFileContents,
  getFbStorageFilenames,
  getFbStorageTrackedUserLocations,
} from './fbStorageFunctions'

export const getRemoteFilenames = async (
  table: TableName | SyncLock | IsClosed | TipFile | 'table-backup'
): Promise<string[]> => {
  const idsList = await getFbStorageFilenames(table)
  return Promise.resolve(idsList)
}

export const createRemoteJsonFile = async (
  table: TableName | SyncLock | FilesMeta | IsClosed | TipFile | 'table-backup',
  id: string,
  fileContent: any
): Promise<CallResult> => {
  try {
    const fbResult = await createFbStorageJsonFile(table, id, fileContent)
    return Promise.resolve(fbResult)
  } catch (error) {
    return Promise.resolve({
      status: 'error',
      isSuccess: false,
      message: error as string,
    })
  }
}

// Create a attachment file (jpg, gpx, pdf, etc)
export const createRemoteFile = async (
  id: string,
  fileContent: File
): Promise<string> => {
  return await createFbStorageFile(id, fileContent)
}

export const deleteRemoteFile = async (
  table: TableName | SyncLock | FilesMeta | FilesContents | IsClosed | TipFile,
  data: string | FileMeta
): Promise<string> => {
  return await deleteFbStorageFile(table, data)
}

export const getRemoteFileContents = async (
  table:
    | TableName
    | SyncLock
    | FilesMeta
    | TipFile
    | FilesContents
    | 'image'
    | 'table-backup'
    | 'location-data',
  id: string,
  fileType?: string
): Promise<Walk[] | User[] | string | FileMeta | any> => {
  return await getFbStorageJsonFileContents(table, id, fileType)
}

export const downloadRemoteFile = async (fileMeta: FileMeta): Promise<void> => {
  return await downloadFbStorageFile(fileMeta)
}

export const getRemoteTrackedUserLocations = async (
  userName: string,
  date: Date,
  setNrLocationFiles: any
): Promise<UsersLocationFiles> => {
  return await getFbStorageTrackedUserLocations(
    userName,
    date,
    setNrLocationFiles
  )
}
